import type { NativeBridge } from "@swiggy-private/native-bridge";
import { APIEvent } from "@swiggy-private/js-utils/dist/fetch/types";

declare global {
    interface Window {
        AndroidBridge?: {
            nativeRequest: (req: string) => void;
        };
        webkit: {
            messageHandlers: {
                nativeRequest: {
                    postMessage(data: unknown): void;
                };
            };
        };
    }
}

export const isApp = () =>
    typeof window !== "undefined" &&
    (!!window.AndroidBridge?.nativeRequest || !!window.webkit?.messageHandlers?.nativeRequest);

export const COMMON_LOGIN_STATUS_ERROR_CODE = [999, 133];

export const COMMON_PIN_NOT_GENERATED_STATUS_ERROR_CODE = [155];

export interface IApiProviderProps {
    authCallback?: VoidFunction;
    sdk: NativeBridge;
    forwardPath: string;
    sendEvent?: APIEvent;
}

export const loginHelper = ({ sdk, forwardPath, authCallback }: IApiProviderProps) => {
    if (authCallback) {
        authCallback();
    } else if (isApp()) {
        sdk.login()
            .then(async (response) => {
                try {
                    if (!response || !response.hasLoggedIn) {
                        return false;
                    }
                    location.replace(forwardPath);
                } catch (_err) {}
            })
            .catch(() => {});
    } else {
        location.replace(`/auth?mweb=1&prevPath=${encodeURIComponent(forwardPath)}`);
    }
};
